import React, { useEffect, useContext, useState, useRef } from 'react'
import { v4 as uuidv4 } from 'uuid';
import axios from "axios"
import * as jsondiffpatch from 'jsondiffpatch';

import APIS, { GLB_URL_APIS } from "../../../../utils/APIS"
import { imageResizer } from "../../../../utils/uploadUtils"

import {
  Box,
  Button,
  Dialog,
} from '@material-ui/core';

import { RotateCcw as RotateCcwIcon, Edit as EditIcon } from 'react-feather';
import { PlusCircle as PlusCircleIcon } from 'react-feather';
import { XCircle as XCircleIcon } from 'react-feather';
import loadingGIF from '../../../../images/loadingGIF.gif'

import GroupPlan from './GroupPlan'
import CertificationModal from './CertificationModal'
import SimulationModal from './SimulationModal'

import SuperAdminContext from "../../../../contexts/SuperAdminContext"

import { adminInputStyle } from "../adminStyles.js"

const OptionsForSelectFormation = ({values}) => {
  let archived = []
  let nonArchived = []
  if (values && values?.length > 0) {
    archived = values?.filter((el) => el.type === "icebreaker" && el.archived === "true")
    nonArchived = values?.filter((el) => el.type === "icebreaker" && el.archived === "false")
  }
  return (
    <>
      <optgroup label="Non archivées">
        {nonArchived?.map((formation, index) => {
          return (
            <option key={index + 'postNameSlect'} value={formation.id}>
              {formation.name}
            </option>
          )
        })}
      </optgroup>
      <optgroup label="Archivées">
        {archived?.map((formation, index) => {
          return (
            <option key={index + 'postNameSlect'} value={formation.id}>
              {formation.name}
            </option>
          )
        })}
      </optgroup>
    </>
  )
}

const GroupForm = ({ isNew, group, setHasChanged, hasChanged, onSubmit, simulationModal, closeSimulationModal }) => {

  const { contents, updateAdminGroupes, setOverlayForSave } = useContext(SuperAdminContext)

  const [allFormations, setAllFormation] = useState([])
  const [id, setId] = useState(null)
  const [name, setName] = useState('')
  const [diplome, setDiplome] = useState('')
  const [code, setCode] = useState('')
  const [titrePlan, setTitrePlan] = useState('')
  const [img, setImg] = useState(null)
  const [maxSlot, setMaxSlot] = useState(0)
  const [nUsers, setNUsers] = useState(0)
  const [icebreaker, setIcebreaker] = useState(60)
  const [icebreakerQuestions, setIcebreakerQuestions] = useState({
    secteurs : false,
    secteursQ : "Quel est votre secteur ?",
    secteursReps : ['défaut'],
    annees : false,
    anneesQ : "Quelle est votre année d'étude ?",
    anneesReps : ['2024'],
    diplome : false,
    diplomeQ : "Quel est votre niveau de diplôme ?",
    diplomeReps : ['M1'],
  })
  const [plan, setPlan] = useState(JSON.parse(JSON.stringify([{ openDate: '', closeDate: '', name: '' , uuid : uuidv4()}])))
  const [initialPlan, setInitialPlan] = useState(JSON.parse(JSON.stringify(plan)))
  const [certification, setCertification] = useState(null)
  const [initialCertification, setInitialCertification] = useState(null)
  const [mailingLists, setMailingLists] = useState([])
  const [certificationModal, setCertificationModal] = useState(false)

  useEffect(() => {
    if (group) {
      setId(group?.id)
      setName(group?.name)
      setDiplome(group?.diplome)
      setCode(group?.code)
      setTitrePlan(group?.titrePlan)
      setImg(group?.img)
      setMaxSlot(group?.maxSlot)
      setNUsers(group?.nUsers)
      setIcebreaker(group?.icebreaker)
      setIcebreakerQuestions(JSON.parse(group?.icebreakerQuestions))
      let uuidPlan = JSON.parse(group?.plan)?.plan
      uuidPlan?.forEach((module) => {
        module.uuid = uuidv4()
      })
      setPlan(uuidPlan)
      setInitialPlan(uuidPlan)
      setCertification(JSON.parse(group?.certification || null))
      setInitialCertification(JSON.parse(group?.certification || null))
    }
  }, [group])

  useEffect(() => {
    APIS.getSuperAdminContents({archived:true}).then((results) => {
      if (results?.formations) {
        setAllFormation(results.formations)
      }
    })
  }, [])


  const updateMailingLists = (result) => {
    let newArr = JSON.parse(JSON.stringify(mailingLists))
    let find = newArr.find((el) => el.uuid === result.uuid)
    if (find) {
      find.length = result.length
    } else {
      newArr.push(result)
    }
    setMailingLists(newArr)
  }



  const deltaPathToElementRemove = (formation, path) => {
    let pathArr = path.substring(1).split('/')
    let element = {...formation};

    for (let i=0; i<pathArr.length; i++) {
      element = element[pathArr[i]]
    }

    return ({el : element, type:"remove"})
  }

  const deltaPathToElementAdd = (formation, path) => {
    let pathArr = path.substring(1).split('/')
    let element = {...formation};

    for (let i=0; i<pathArr.length; i++) {
      element = element[pathArr[i]]
    }

    return ({el : element, type:"add"})
  }

  const deltaPathToElementReplace = (formation, path) => {
    let pathArr = path.substring(1).split('/')
    let keyToChange = pathArr[pathArr.length - 1]
    let element = {...formation};

    for (let i=0; i<pathArr.length-1; i++) {
      element = element[pathArr[i]]
    }

    return ({el : element, key : keyToChange, type:"update"})
  }

  const onSubmitForm = async(e) => {
    e.preventDefault()
    var isGood = true
    var error = ""
    if (
      code === '' ||
      name === '' ||
      titrePlan === '' ||
      maxSlot === 0
    ) {
      isGood = false
      error = "nom, code, titre plan ou nombre utilisateurs"
    }
    var newPlan = plan
    newPlan.forEach((item, i) => {
      if (item.closeDate === '' || item.openDate === '' || item.name === '' || item.id === null) {
        isGood = false
        error = "dates ouvertures / fermetures"
      }

      if (item.enableRat === true) {
        if (item.openDateRat === '' || item.openDateRat === undefined || item.closeDateRat === '' || item.closeDateRat === undefined) {
          isGood = false
          error = "dates ouvertures / fermetures rattrapages"
        } else {
          let formatCloseDate = new Date(item.closeDate)
          let formatOpenDateRat = new Date(item.openDateRat)
          if (formatOpenDateRat < formatCloseDate) {
            isGood = false
            error = "date de rattrapages avant date de fermeture"
          }
        }
      }
      contents?.forEach((forma) => {
        if (forma?.id === item?.id) {
          newPlan[i].surname = forma?.surname
          newPlan[i].color = forma?.color?.color
        }
      })
    })
    //on check toutes les réponses et les questions pour les "icebreaker questions"
    if (icebreakerQuestions?.secteurs === true) {
      if (icebreakerQuestions?.secteursQ === "") {
        isGood = false
        error = "question icebreaker secteurs"
      }
      icebreakerQuestions?.secteursReps?.forEach((rep) => {
        if (rep === "") {
          isGood = false
          error = "réponses icebreaker secteurs"
        }
      })
    }
    if (icebreakerQuestions?.annees === true) {
      if (icebreakerQuestions?.anneesQ === "") {
        isGood = false
        error = "question icebreaker années"
      }
      icebreakerQuestions?.anneesReps?.forEach((rep) => {
        if (rep === "") {
          isGood = false
          error = "réponses icebreaker années"
        }
      })
    }
    if (icebreakerQuestions?.diplome === true) {
      if (icebreakerQuestions?.diplomeQ === "") {
        isGood = false
        error = "question icebreaker diplôme"
      }
      icebreakerQuestions?.diplomeReps?.forEach((rep) => {
        if (rep === "") {
          isGood = false
          error = "réponses icebreaker diplôme"
        }
      })
    }
    if (isGood) {
      const newGroupe = {
        id: id,
        code: code,
        name: name,
        diplome : diplome,
        titrePlan: titrePlan,
        maxSlot: maxSlot,
        plan: newPlan,
        icebreaker : parseInt(icebreaker),
        icebreakerQuestions : JSON.stringify(icebreakerQuestions)
      }
      if (newGroupe.id !== null && (JSON.stringify(newPlan) !== JSON.stringify(initialPlan))) {
        var diffpatcher = jsondiffpatch.create({
          cloneDiffValues: true,
          objectHash: function(obj, index) {
            return obj.uuid || '$$index:' + index;
          },
          arrays: {
            // default true, detect items moved inside the array (otherwise they will be registered as remove+add)
            detectMove: false,
            // default false, the value of items moved is not included in deltas
            includeValueOnMove: false,
          },
          textDiff: {
            minLength: 99999999999999,
          },
        });
        let delta = diffpatcher.diff(initialPlan, newPlan);
        let deltaFormat = jsondiffpatch.formatters.jsonpatch.format(delta)
        let finalChanges = []
        let finalChangesForCertification = []
        deltaFormat.forEach((change) => {
          if (change.op === "replace") {
            let infosUpdate = deltaPathToElementReplace(newPlan, change.path)
            if (infosUpdate.key === "id" || infosUpdate.key === "openDate" || infosUpdate.key === "closeDate") {
              let find = finalChanges.find((el) => el.uuid === infosUpdate.el.uuid)
              if (find) {
                let newArr = find.arr;
                newArr.push(infosUpdate)
                find.arr = newArr
              } else {
                finalChanges.push({uuid : infosUpdate.el.uuid, arr:[infosUpdate]})
              }
            }
          } else if (change.op === "add") {
            let infosAdd = deltaPathToElementAdd(newPlan, change.path)
            //console.log("add", infosAdd)
          } else  if (change.op === "remove") {
            let infosRemove = deltaPathToElementRemove(initialPlan, change.path)
            let find = finalChanges.find((el) => el.uuid === infosRemove.el.uuid)
            if (find) {
              let newArr = find.arr;
              newArr.push(infosRemove)
              find.arr = newArr
            } else {
              finalChanges.push({uuid : infosRemove.el.uuid, arr:[infosRemove]})
            }
          }
        })
        finalChangesForCertification = JSON.parse(JSON.stringify(finalChanges))
        finalChanges = finalChanges.filter((el) => {
          let nbrMailing = mailingLists?.find((list) => list.uuid === el.uuid)?.length
          if (nbrMailing > 0) {
            return true
          } else {
            return false
          }
        })
        finalChanges.forEach((el) => {
          if (el.arr.length > 1) {
            //on cherche si il y a un update de l'ID, donc un changement de module
            let find = el.arr.find((update) => update.key === "id" && update.type === "update")
            if (find) {
              el.arr = [find]
            }
          }
        })
        //on pose la question /on informe pour chaque
        let informSupprModule = false
        let informModifDateModule = false
        let askUpdateMailingForUpdateModule = false
        let responseUpdateMailingForUpdateModule = null
        let changesArray = []
        finalChanges.forEach((el) => {
          if (el.arr[0].type === "remove") {
            informSupprModule = true
            changesArray.push({type:"removeMailing", contentID : el.arr[0].el.id, groupeID : id})
          } else if (el.arr[0].type === "update" && el.arr[0].key === "id") {
            askUpdateMailingForUpdateModule = true
            let oldContentID = initialPlan?.find((plan) => plan.uuid === el.arr[0].el.uuid)
            let newDates = newPlan.find((plan) => plan.uuid === el.arr[0].el.uuid)
            changesArray.push({type:"updateMailing", oldContentID : oldContentID.id, newContentID : el.arr[0].el.id, newOpenDate : newDates.openDate, newCloseDate : newDates.closeDate, groupeID : id, })
          } else {
            informModifDateModule = true
            let json = {type:"updateDates", contentID : el.arr[0].el.id, groupeID : id}
            el.arr.forEach((modif) => {
              json[modif.key] = modif.el[modif.key]
            })
            changesArray.push(json)
          }
        })
        if (informSupprModule === true && informModifDateModule === true) {
          let infos = await asyncMuiConfirm({ title: "Informations !", description: "- La suppresion d'un module entraine la suppresion des mailings associés\n- La modification des dates d'un module entraine la modification des dates des mailings associés", confirmationText:"Fermer", allowClose:false, cancellationButtonProps:{style:{display:"none"}}, dialogProps:{style:{whiteSpace:"pre-line"}}})
        } else if (informSupprModule === true) {
          let infos = await asyncMuiConfirm({ title: "Informations !", description: "La suppresion d'un module entraine la suppresion des mailings associés", confirmationText:"Fermer", allowClose:false, cancellationButtonProps:{style:{display:"none"}}})
        } else if (informModifDateModule === true) {
          let infos = await asyncMuiConfirm({ title: "Informations !", description: "La modification des dates d'un module entraine la modification des dates des mailings associés", confirmationText:"Fermer", allowClose:false, cancellationButtonProps:{style:{display:"none"}}})
        }
        if (askUpdateMailingForUpdateModule === true) {
          let responseUpdateMailingForUpdateModule = await asyncMuiConfirm({ title: "Informations !", description: "Vous avez remplacé un ou plusieurs modules, voulez-vous supprimer ou garder les mailings associés ?", cancellationText:"Supprimer", confirmationText:"Garder", allowClose:false})
          if (responseUpdateMailingForUpdateModule === "cancel") {
            changesArray.forEach((change) => {
              if (change.type === "updateMailing") {
                change.type = "removeMailing"
                change.contentID = change.oldContentID
                delete change.oldContentID
                delete change.newContentID
                delete change.newOpenDate
                delete change.newCloseDate
              }
            })
          }
        }
        setOverlayForSave(true)
        //gestion de la certification
        let changesArrayForCertification = []
        finalChangesForCertification.forEach((el) => {
          if (el.arr[0].type === "remove") {
            changesArrayForCertification.push({type:"remove", contentID : el.arr[0].el.id, groupeID : id})
          } else if (el.arr[0].type === "update" && el.arr[0].key === "id") {
            let oldContentID = initialPlan?.find((plan) => plan.uuid === el.arr[0].el.uuid)
            changesArrayForCertification.push({type:"update", contentID : oldContentID.id, newContentID : el.arr[0].el.id, groupeID : id, })
          }
        })
        let newCertification = null
        if (changesArrayForCertification.length > 0 && certification) {
          newCertification = JSON.parse(JSON.stringify(certification))
          newCertification = newCertification.filter((el) => {
            let find = changesArrayForCertification.find((f) => f.contentID === el.id)
            if (find) {
              return false
            } else {
              return true
            }
          })
          //console.log(newCertification)
        }
        APIS.editMailingPlan({array : JSON.stringify(changesArray)}).then((result) => {
          if (result?.isOk === true) {
            onSubmit(newGroupe)
            //on actualise le plan et le initialPlan actuel
            let newUuidPlan = JSON.parse(JSON.stringify(plan))
            newUuidPlan.forEach((module) => {
              module.uuid = uuidv4()
            })
            setPlan( JSON.parse(JSON.stringify(newUuidPlan)) )
            setInitialPlan(  JSON.parse(JSON.stringify(newUuidPlan)) )

            //on reload les mails
            let reloadMailings = document.getElementsByClassName("getMailingForThisContentClick");
            for (var i = 0; i < reloadMailings.length; i++) {
              try {
                reloadMailings[i].click()
              } catch(e) { console.log(e) }
            }

            //on gère la certification
            if (changesArrayForCertification.length > 0 && certification) {
              APIS.saveGroupeCertification({id : id, certification : JSON.stringify(newCertification)}).then((result2) => {
                if (result2?.message === "saveCertification") {
                  setCertification( JSON.parse(JSON.stringify(newCertification)) )
                  setInitialCertification( JSON.parse(JSON.stringify(newCertification)) )
                  setOverlayForSave(false)
                } else {
                  alert("Erreur 1")
                  setOverlayForSave(false)
                }
              })
            } else {
              setOverlayForSave(false)
            }

          } else {
            alert("Erreur 2")
            setOverlayForSave(false)
          }
        })
      } else {
        onSubmit(newGroupe)
      }
    } else {
      alert("Informations manquantes : "+error)
    }
  }


  const onIcebreakerQuestionsChange = (e) => {
    let { id, value } = e.target
    if (value === "true") { value = true }
    if (value === "false") { value = false }
    let split = id.split("_")
    setIcebreakerQuestions({...icebreakerQuestions, [split[1]]: value })
    setHasChanged(true)
  }

  const onPlanChange = (newPlan) => {
    setPlan(newPlan)
    setHasChanged(true)
  }

  const saveCertification = (newCertification) => {
    APIS.saveGroupeCertification({id : id, certification : JSON.stringify(newCertification)}).then((result) => {
      if (result?.message === "saveCertification") {
        updateAdminGroupes(group?.archived)
        setCertification( JSON.parse(JSON.stringify(newCertification)) )
        setInitialCertification( JSON.parse(JSON.stringify(newCertification)) )
        setCertificationModal(false)
      } else {
        alert("Erreur 3")
      }
    })
  }


  return (
    <>
      <form noValidate onSubmit={onSubmitForm}>
        <Box sx={{ padding:"0px 10px" }}>
          <Box sx={{display:"flex", gap:"30px"}}>
            <Box sx={{flexGrow : 1}}>
              <Box sx={{ width: '100%', marginBottom:"10px", fontWeight:"bold", fontSize:"18px" }}>Informations principales</Box>
              <Box>
                <Box>Nom du groupe</Box>
                <input
                  onChange={(e) => {
                    setName(e?.target?.value)
                    setHasChanged(true)
                  }}
                  value={name}
                  id="name"
                  name="name"
                  placeholder="Bayard"
                  type="text"
                  style={adminInputStyle}
                />
              </Box>

              <Box>
                <Box>Code du groupe</Box>
                <input
                onChange={(e) => {
                  setCode(e?.target?.value)
                  setHasChanged(true)
                }}
                  value={code}
                  id="code"
                  name="code"
                  placeholder="CodeBayard"
                  type="text"
                  style={adminInputStyle}
                />
              </Box>

              <Box>
                <Box>Nom du diplôme</Box>
                <input
                  onChange={(e) => {
                    setDiplome(e?.target?.value)
                    setHasChanged(true)
                  }}
                  value={diplome}
                  id="diplome"
                  name="diplome"
                  placeholder="RNCPXXX"
                  type="text"
                  style={adminInputStyle}
                />
              </Box>

              <Box>
                <Box>{nUsers} utilisateurs sur (max):</Box>
                <input
                  onChange={(e) => {
                    setMaxSlot(e?.target?.value)
                    setHasChanged(true)
                  }}
                  value={maxSlot}
                  id="maxSlot"
                  name="maxSlot"
                  placeholder="0"
                  type="number"
                  style={adminInputStyle}
                />
              </Box>
            </Box>
            {isNew !== true &&
              <div>
                <Box sx={{ width: '100%', fontWeight:"bold", fontSize:"18px" }}>Image du groupe</Box>
                <div style={{width : '100%', display:"flex", flexDirection:"column", gap:"10px", justifyContent:"center", alignItems:"center",}}>
                  <div style={{width:"100px", height:"100px", display:"flex", justifyContent:"center", alignItems:"center"}}>
                    {img === null ? (
                      <center>
                        Défaut<br/>Rising UP
                      </center>
                    ) : (
                      <img src={GLB_URL_APIS+"/groupesLogos/"+img} style={{width:"100px", height:"100px", objectFit:"contain"}} />
                    )}
                  </div>
                  <div style={{width : '100%', display:"flex", justifyContent:"center", gap:"15px",}}>
                    {img !== null &&
                      <Button
                        variant="text"
                        sx={{
                          padding:0,
                          minWidth:0,
                          minHeight:"35px !important",
                          height:"35px",
                          "&:hover":{
                            background:"transparent",
                          }
                        }}
                        onClick={() => {
                          APIS.resetGroupLogo({id : id, oldImg : img}).then((result) => {
                            if (result?.message === "resetLogo") {
                              setImg(null)
                              updateAdminGroupes()
                            }
                          })
                        }}
                      >
                        <RotateCcwIcon
                          color="black"
                          size={20}
                        />
                      </Button>
                    }

                    <Button
                      variant="text"
                      component="label"
                      sx={{
                        padding:0,
                        minWidth:0,
                        minHeight:"35px !important",
                        height:"35px",
                        "&:hover":{
                          background:"transparent",
                        }
                      }}
                    >
                      <EditIcon
                        color="black"
                        size={20}
                      />
                      <input
                        type='file'
                        id='file'
                        accept="image/*"
                        style={{display: 'none'}}
                        onChange={async (event)=> {
                          if (event.target?.files[0]) {
                            let file = event.target.files[0]
                            let resizedFile = await imageResizer(file)

                            const formData = new FormData();
                            formData.append('id', id)
                            formData.append('oldImg', img)
                            formData.append('file', resizedFile);
                            try {
                              const onUploadProgress = (progressEvent) => {
                                let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                                console.log(progress+" %")
                                //setProgress(progress)
                              }
                              const res = await axios.put(GLB_URL_APIS + '/groupe/admin/updateLogo', formData, {
                                onUploadProgress : onUploadProgress,
                                withCredentials: true,
                              })
                              if (res && res.data && res.data.message === "updateLogo" && res.data.file) {
                                //on recharge tous les plans
                                setImg(res.data.file)
                                updateAdminGroupes()
                              }
                            } catch (err) {
                              console.log(err)
                            }

                          }
                        }}
                      />
                    </Button>
                  </div>
                </div>
              </div>
            }
          </Box>

          {group?.isTheScanGroupe !== 1 &&
            <>
              <Box sx={{ width: '100%', marginTop: '30px', marginBottom:"10px", fontWeight:"bold", fontSize:"18px" }}>IceBreaker</Box>
              <select
                onChange={(e) => {
                  setIcebreaker(e?.target?.value)
                  setHasChanged(true)
                }}
                id="icebreaker"
                name="icebreaker"
                style={{width:'307px', marginLeft:'10px',}}
                value={icebreaker}
              >
                <OptionsForSelectFormation
                  values={allFormations}
                />
              </select>
              <Box sx={{ width: '100%', marginTop: '30px', marginBottom:'10px', fontWeight:"bold", fontSize:"18px" }}>IceBreaker Questions</Box>
              <div style={{marginLeft:'10px'}}>
                <div style={{fontSize:'14px', marginBottom:'20px'}}>
                  <div style={{display:"flex", alignItems:"center"}}>
                    <div style={{fontWeight:"bold"}}>Secteurs &nbsp;</div>
                    <select
                      onChange={onIcebreakerQuestionsChange}
                      id="icebreakerQuestions_secteurs"
                      name="icebreakerQuestions_secteurs"
                      style={{width:'200px'}}
                      value={icebreakerQuestions?.secteurs || false}
                    >
                      <option value={false}>
                        Ne pas poser la question
                      </option>
                      <option value={true}>
                        Poser la question
                      </option>
                    </select>
                  </div>
                  {(icebreakerQuestions?.secteurs === true && icebreakerQuestions?.secteursReps) &&
                    <div style={{marginLeft:'10px'}}>
                      <div style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                        Question : &nbsp;
                        <input
                        onChange={onIcebreakerQuestionsChange}
                        id="icebreakerQuestions_secteursQ"
                        name="icebreakerQuestions_secteursQ"
                        style={{width:'400px', marginTop:0,}}
                        value={icebreakerQuestions?.secteursQ || ""}
                        type="text"
                        />
                      </div>
                      <div style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                        Réponses possibles : &nbsp;
                        <PlusCircleIcon
                          color="black"
                          size={15}
                          style={{cursor:"pointer"}}
                          onClick={() => {
                            let newArr = [...icebreakerQuestions?.secteursReps]
                            newArr.push('défaut')
                            setIcebreakerQuestions({...icebreakerQuestions, secteursReps : newArr })
                            setHasChanged(true)
                          }}
                        />
                      </div>
                      <div style={{marginLeft:'10px'}}>
                        {icebreakerQuestions?.secteursReps.map((rep, i) => {
                          return (
                            <div key={"anneesReps"+i} style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                              <input
                                style={{width:'200px', marginTop:0,}}
                                onChange={(e) => {
                                  let newArr = [...icebreakerQuestions?.secteursReps]
                                  newArr.splice(i, 1, e.target.value)
                                  setIcebreakerQuestions({...icebreakerQuestions, secteursReps : newArr })
                                  setHasChanged(true)
                                }}
                                value={icebreakerQuestions?.secteursReps[i]}
                                type="text"
                              />
                              {icebreakerQuestions?.secteursReps?.length > 1 &&
                                <XCircleIcon
                                  color="black"
                                  size={14}
                                  style={{marginLeft:"10px", cursor:"pointer"}}
                                  onClick={() => {
                                    let newArr = [...icebreakerQuestions?.secteursReps]
                                    newArr.splice(i, 1);
                                    setIcebreakerQuestions({...icebreakerQuestions, secteursReps : newArr })
                                    setHasChanged(true)
                                  }}
                                />
                              }
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  }
                </div>

                <div style={{fontSize:'14px', marginBottom:'20px'}}>
                  <div style={{display:"flex", alignItems:"center"}}>
                    <div style={{fontWeight:"bold"}}>Années d'études &nbsp;</div>
                    <select
                      onChange={onIcebreakerQuestionsChange}
                      id="icebreakerQuestions_annees"
                      name="icebreakerQuestions_annees"
                      style={{width:'200px'}}
                      value={icebreakerQuestions?.annees || false}
                    >
                      <option value={false}>
                        Ne pas poser la question
                      </option>
                      <option value={true}>
                        Poser la question
                      </option>
                    </select>
                  </div>
                  {(icebreakerQuestions?.annees === true && icebreakerQuestions?.anneesReps) &&
                    <div style={{marginLeft:'10px'}}>
                      <div style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                        Question : &nbsp;
                        <input
                        onChange={onIcebreakerQuestionsChange}
                        id="icebreakerQuestions_anneesQ"
                        name="icebreakerQuestions_anneesQ"
                        style={{width:'400px', marginTop:0,}}
                        value={icebreakerQuestions?.anneesQ || ""}
                        type="text"
                        />
                      </div>
                      <div style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                        Réponses possibles : &nbsp;
                        <PlusCircleIcon
                          color="black"
                          size={15}
                          style={{cursor:"pointer"}}
                          onClick={() => {
                            let newArr = [...icebreakerQuestions?.anneesReps]
                            newArr.push('2024')
                            setIcebreakerQuestions({...icebreakerQuestions, anneesReps : newArr })
                            setHasChanged(true)
                          }}
                        />
                      </div>
                      <div style={{marginLeft:'10px'}}>
                        {icebreakerQuestions?.anneesReps.map((rep, i) => {
                          return (
                            <div key={"anneesReps"+i} style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                              <input
                                style={{width:'200px', marginTop:0,}}
                                onChange={(e) => {
                                  let newArr = [...icebreakerQuestions?.anneesReps]
                                  newArr.splice(i, 1, e.target.value)
                                  setIcebreakerQuestions({...icebreakerQuestions, anneesReps : newArr })
                                  setHasChanged(true)
                                }}
                                value={icebreakerQuestions.anneesReps[i]}
                                type="text"
                              />
                              {icebreakerQuestions?.anneesReps?.length > 1 &&
                                <XCircleIcon
                                  color="black"
                                  size={14}
                                  style={{marginLeft:"10px", cursor:"pointer"}}
                                  onClick={() => {
                                    let newArr = [...icebreakerQuestions?.anneesReps]
                                    newArr.splice(i, 1);
                                    setIcebreakerQuestions({...icebreakerQuestions, anneesReps : newArr })
                                    setHasChanged(true)
                                  }}
                                />
                              }
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  }
                </div>

                <div style={{fontSize:'14px', marginBottom:'5px'}}>
                  <div style={{display:"flex", alignItems:"center"}}>
                    <div style={{fontWeight:"bold"}}>Diplome &nbsp;</div>
                    <select
                      onChange={onIcebreakerQuestionsChange}
                      id="icebreakerQuestions_diplome"
                      name="icebreakerQuestions_diplome"
                      style={{width:'200px'}}
                      value={icebreakerQuestions?.diplome || false}
                    >
                      <option value={false}>
                        Ne pas poser la question
                      </option>
                      <option value={true}>
                        Poser la question
                      </option>
                    </select>
                  </div>
                  {(icebreakerQuestions?.diplome === true && icebreakerQuestions?.diplomeReps) &&
                    <div style={{marginLeft:'10px'}}>
                      <div style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                        Question : &nbsp;
                        <input
                        onChange={onIcebreakerQuestionsChange}
                        id="icebreakerQuestions_diplomeQ"
                        name="icebreakerQuestions_diplomeQ"
                        style={{width:'400px', marginTop:0,}}
                        value={icebreakerQuestions?.diplomeQ || ""}
                        type="text"
                        />
                      </div>
                      <div style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                        Réponses possibles : &nbsp;
                        <PlusCircleIcon
                          color="black"
                          size={15}
                          style={{cursor:"pointer"}}
                          onClick={() => {
                            let newArr = [...icebreakerQuestions?.diplomeReps]
                            newArr.push('M1')
                            setIcebreakerQuestions({...icebreakerQuestions, diplomeReps : newArr })
                            setHasChanged(true)
                          }}
                        />
                      </div>
                      <div style={{marginLeft:'10px'}}>
                        {icebreakerQuestions?.diplomeReps.map((rep, i) => {
                          return (
                            <div key={"diplomeReps"+i} style={{display:"flex", alignItems:"center", marginTop:'5px'}}>
                              <input
                                style={{width:'200px', marginTop:0,}}
                                onChange={(e) => {
                                  let newArr = [...icebreakerQuestions?.diplomeReps]
                                  newArr.splice(i, 1, e.target.value)
                                  setIcebreakerQuestions({...icebreakerQuestions, diplomeReps : newArr })
                                  setHasChanged(true)
                                }}
                                value={icebreakerQuestions.diplomeReps[i]}
                                type="text"
                              />
                              {icebreakerQuestions?.diplomeReps?.length > 1 &&
                                <XCircleIcon
                                  color="black"
                                  size={14}
                                  style={{marginLeft:"10px", cursor:"pointer"}}
                                  onClick={() => {
                                    let newArr = [...icebreakerQuestions?.diplomeReps]
                                    newArr.splice(i, 1);
                                    setIcebreakerQuestions({...icebreakerQuestions, diplomeReps : newArr })
                                    setHasChanged(true)
                                  }}
                                />
                              }
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  }
                </div>

              </div>
            </>
          }

          <Box sx={{ width: '100%',  marginTop: '30px', marginBottom:'10px', fontWeight:"bold", fontSize:"18px" }}>Plan de formation</Box>
          <Box>
            <Box sx={{
              display:"flex",
              flexDirection:"column",
            }}>
              <input
                onChange={(e) => {
                  setTitrePlan(e?.target?.value)
                  setHasChanged(true)
                }}
                value={titrePlan}
                id="titrePlan"
                name="titrePlan"
                placeholder="#Management"
                type="text"
                style={adminInputStyle}
              />
              {allFormations.length !== 0 &&
                <GroupPlan
                  groupeName={name}
                  groupeID={id}
                  plan={plan}
                  allFormations={allFormations}
                  hasChanged={hasChanged}
                  setHasChanged={setHasChanged}
                  updateMailingLists={updateMailingLists}
                  isTheScanGroupe={group?.isTheScanGroupe}
                  updateFct={(e, index) => {
                    let newPlan = [...plan]
                    let find = allFormations.find((el => el.id === parseInt(e.target.value)))
                    newPlan[index]["id"] = find.id
                    newPlan[index]["name"] = find.name
                    onPlanChange(newPlan)
                  }}
                  updateEnableRat={(e, index) => {
                    let newPlan = [...plan]
                    newPlan[index][e.target.id] = e.target.checked
                    onPlanChange(newPlan)
                  }}
                  updateDatesFct={(e, index) => {
                    let newPlan = [...plan]
                    newPlan[index][e.target.id] = e.target.value
                    onPlanChange(newPlan)
                  }}
                  updateAnneeFct={(e, index) => {
                    let newPlan = [...plan]
                    newPlan[index][e.target.id] = e.target.value
                    onPlanChange(newPlan)
                  }}
                  addFct={() => {
                    let newPlan = [...plan]
                    newPlan.push({ closeDate: '', openDate: '', name: '', id : undefined })
                    onPlanChange(newPlan)
                  }}
                  deleteFct={(index) => {
                    let newPlan = [...plan]
                    newPlan.splice(index, 1)
                    onPlanChange(newPlan)
                  }}
                />
              }
            </Box>
          </Box>

          <button hidden type="submit" id="hidden_form_submit">
            Éditer le groupe
          </button>
        </Box>
        <Box style={{margin : "20px 10px",}}>
          <Button
            variant="contained"
            disabled={(id === null || hasChanged === true)}
            sx={{ minHeight:"35px !important" }}
            onClick={() => {
              setCertificationModal(true)
            }}
          >
            Gestion de la certification
          </Button>
        </Box>

        {certificationModal === true &&
          <CertificationModal
            isOpen={certificationModal}
            groupState={{
              plan : plan,
              allFormations : allFormations,
              certification : certification,
              initialCertification : initialCertification,

            }}
            saveCertification={saveCertification}
            onClose={() => { setCertificationModal(false) }}
          />
        }

        {simulationModal === true &&
          <SimulationModal
            reloadResults={() => {
              document.location.reload()
            }}
            groupState={{
              maxSlot : maxSlot,
              nUsers : nUsers,
              icebreakerQuestions : icebreakerQuestions,
              id : id,
              code : code,
              icebreaker : icebreaker,
              plan : plan,
            }}
            isOpen={simulationModal}
            onClose={() => {
              closeSimulationModal()
            }}
          />
        }

      </form>
    </>
  )
};

export default GroupForm;
